import { lazy, Suspense } from 'react';
import Fallback from '../custom/fallback/fallback';
import DashboardLayout from "./dashboardLayout/dashboardLayout";
const Main = lazy(() => import('../components/inductionPayment/main'));

const InductionPayment = () => {
    return (
        <DashboardLayout 
            heading="Induction Payment"
        >
            <Suspense fallback={<Fallback />}>
                <Main />
            </Suspense>
        </DashboardLayout>
    );
};

export default InductionPayment;